<div class="main-container">
    <!-- Full-height Sidebar on the left -->
    <div class="sidebar-wrapper">
        <app-sidebar></app-sidebar>
    </div>

    <!-- Right side container (navbar + content + footer) -->
    <div class="right-side-container"
        [ngClass]="sidebarStateService.getSidebarState()? 'sidebar-expanded': 'sidebar-collapsed'">

        <!-- Navbar at top of right side -->
        <app-navbar class="navbar-fixed"></app-navbar>

        <!-- Main content area (scrollable) -->
        <div class="main-content">
            <mat-card class="content-area">
                <ng-content></ng-content>
            </mat-card>
        </div>

        <!-- Footer at bottom of right side -->
        <!-- <app-footer class="footer-fixed"></app-footer> -->
    </div>
</div>